import { inject } from '@angular/core';
import { CanMatchFn, Routes } from '@angular/router';
import { WHLoginDataService } from '@workheld/workheld-shared-lib';
import { TEAM_PLANNER_V2_FEATURE_KEY } from './team-planner-v2.constants';

/** Team Planner 2.0 only for tenants with `advancedTeamPlanner.v2.enabled`; everyone else keeps the classic planner. */
export const teamPlannerV2Match: CanMatchFn = () =>
  inject(WHLoginDataService).featureConfigMap$.value.get(
    TEAM_PLANNER_V2_FEATURE_KEY,
  ) === true;

export const TEAM_PLANNER_V2_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./team-planner-v2-page.component').then(
        (m) => m.TeamPlannerV2PageComponent,
      ),
  },
];
